import { render, staticRenderFns } from "./OtbnArgentina.vue?vue&type=template&id=77beb323&scoped=true&lang=pug"
import script from "./OtbnArgentina.vue?vue&type=script&lang=js"
export * from "./OtbnArgentina.vue?vue&type=script&lang=js"
import style0 from "./OtbnArgentina.vue?vue&type=style&index=0&id=77beb323&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77beb323",
  null
  
)

export default component.exports